import {
  TOUR_PROPERTIES,
  setLocalStorageItem,
} from '@learningblocks/protocol-constants/lib/Utilities';

export function endTour(state) {
  return {
    ...state,
    ...setTourFlase(),
  };
}
function setTourFlase() {
  setLocalStorageItem(TOUR_PROPERTIES.IS_EXPERIMENTAL_DESIGN_FINISHED, true);
  return {tour: false};
}
